// extracted by mini-css-extract-plugin
export default {"header":"header_header__HGGiz","childrn":"header_childrn__+6oJA","title":"header_title__Z7fLW","gridSettings":"header_gridSettings__KJCJo"};